import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filters from 'views/agent/configuration/securityChanges/filter'; // Importing Filters component
import Table from 'views/agent/configuration/securityChanges/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the security changes view.
 * @extends JetView
 */
export default class securityChangesView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
            ],
        };
        const left = {
            // Left side configuration
            rows: [
                {
                    view: 'toolbar',
                    css: theme,
                    elements: [{ view: 'label', label: _('QR'), width: 150 }], // QR label
                },
                {
                    view: 'template', // Template for QR code display
                    id: 'templateQR',
                    onClick: {
                        copy_text: function (ev, id) {
                            // Click event to copy text
                            var copyText = document.getElementById('lname'); // Text input element
                            copyText.select(); // Select the text
                            copyText.setSelectionRange(0, 99999); // Set selection range
                            document.execCommand('copy'); // Execute copy command
                            webix.message(_('QR Copiado!')); // Show message on copy
                        },
                    },
                },
                {
                    view: 'label', // Error label for no QR configured
                    label: 'No tienes un QR Configurado.',
                    localId: 'label',
                    id: 'labelError',
                },
            ],
        };
        if (
            !devConfig.getPermAction(
                // Check permissions for action
                'betShopManagementConfigurationQrgoogleMenu',
                'Menu',
            )
        ) {
            this.show('../'); // Redirect if no permission
        } else {
            return {
                type: 'wide',
                cols: [left], // Return layout configuration
            };
        }
    }

    /**
     * Initializes the view and fetches QR code data.
     */
    init() {
        const cur_user = this.getParam('user', true); // Get current user parameter
        $$('labelError').hide(); // Hide error label initially
        webix
            .ajax() // AJAX request to fetch QR code
            .get(
                devConfig.geturlApi() + 'Client/GetQRGoogle', // API endpoint
                'id=' + cur_user, // Query parameter
                {
                    error: function (text, data, XmlHttpRequest) {
                        // Error handling
                        webix.message('Error! '); // Show error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        // Success handling
                        var text = JSON.parse(text); // Parse response
                        if (!text.HasError) {
                            // Check for errors in response
                            $$('templateQR').show(); // Show QR template
                            $$('labelError').hide(); // Hide error label
                            $$('templateQR').setHTML(
                                // Set HTML for QR display
                                `<div style="text-align: center;">
                          <img style="display:inline-block" src="` +
                                    text.data +
                                    `">
                       </div>
                       <br>
                       <div style="text-align: center;">
                          <input type="text" id="lname" name="lname"
                              style="width: 50%;
                              padding: 12px 20px;
                              margin: 8px 0;
                              display: inline-block;
                              border: 1px solid #ccc;
                              border-radius: 4px;
                              box-sizing: border-box;
                              text-align: center;"
                              value="` +
                                    text.text +
                                    `">
                          <button class='button-login copy_text'
                            style="
                            background-color: #263043 !important;
                            color: white;
                            padding: 14px 20px;
                            margin: 8px 0;
                            border: none;
                            border-radius: 4px;
                            cursor: pointer;"><span class="icon-copy"></span></button>
                       </div>
                      `,
                            );
                        } else {
                            $$('templateQR').hide(); // Hide QR template on error
                            $$('labelError').show(); // Show error label
                        }
                    },
                },
            );
    }
}

// FILE DOCUMENTED
